import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { BrowserModule, Title } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'

import {
  AppLogger,
  AppService,
  AuthService,
  CartApiService,
  CartService,
  CartStorageService,
  CIDService,
  CoreEnvironmentService,
  CoreModule,
  CoreSettingsService,
  I18nService,
  InternationalizationService,
  LangInterceptor,
  LicensesBulkDiscountService,
  LicenseService,
  PaymentService,
  PlayerCore,
  PlayerLogic,
  ProducerService,
  SHOPPING_CART_APP_TYPE,
  shoppingCartApp,
  SsrService,
  StorageService,
  StubTrackResolver,
  TrackResolverAbstract,
  TracksService,
  UtilsService,
  WithCredentialsInterceptor
} from 'core'

import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { BmprodCookiePolicyPopupComponent } from './components/bmprod-cookie-policy-popup/bmprod-cookie-policy-popup.component'
import { BmprodFooterComponent } from './components/bmprod-footer/bmprod-footer.component'
import { BmprodHeaderComponent } from './components/bmprod-header/bmprod-header.component'
import { BmprodPlayerComponent } from './components/bmprod-player/bmprod-player.component'
import { BmprodSelectLicensePopupComponent } from './components/bmprod-select-license-popup/bmprod-select-license-popup.component'
import { BmprodShareTrackPopupComponent } from './components/bmprod-share-track-popup/bmprod-share-track-popup.component'
import { BmprodBeatPageComponent } from './components/pages/bmprod-beat-page/bmprod-beat-page.component'
import { BmprodCheckoutPageComponent } from './components/pages/bmprod-checkout-page/bmprod-checkout-page.component'
import { BmprodCookiePolicyPageComponent } from './components/pages/bmprod-cookie-policy-page/bmprod-cookie-policy-page.component'
import { BmprodHomePageComponent } from './components/pages/bmprod-home-page/bmprod-home-page.component'
import { BmprodPageNotFoundComponent } from './components/pages/bmprod-page-not-found/bmprod-page-not-found.component'
import { BmprodUserAgreementPageComponent } from './components/pages/bmprod-user-agreement-page/bmprod-user-agreement-page.component'
import { LocalCoreSettingsService } from './services/settings/LocalCoreSettingsService'

let service = null

export function i18ServiceFactory(storageService: StorageService) {
  if (service === null) {
    service = new I18nService(storageService)
  }
  return service
}

function appLoggerFactory(coreSettingsService: CoreSettingsService) {
  return new AppLogger(coreSettingsService.settings.appLoggerLevel)
}

@NgModule({
  declarations: [
    AppComponent,
    BmprodUserAgreementPageComponent,
    BmprodHomePageComponent,
    BmprodHeaderComponent,
    BmprodFooterComponent,
    BmprodBeatPageComponent,
    BmprodCheckoutPageComponent,
    BmprodShareTrackPopupComponent,
    BmprodSelectLicensePopupComponent,
    BmprodPlayerComponent,
    BmprodPageNotFoundComponent,
    BmprodCookiePolicyPageComponent,
    BmprodCookiePolicyPopupComponent
  ],
  bootstrap: [AppComponent],
  imports: [BrowserModule, AppRoutingModule, CoreModule, ReactiveFormsModule, FormsModule, BrowserAnimationsModule],
  providers: [
    CartService,
    StorageService,
    CoreEnvironmentService,
    UtilsService,
    TracksService,
    AuthService,
    CIDService,
    LicenseService,
    LicensesBulkDiscountService,
    PlayerLogic,
    PlayerCore,
    PaymentService,
    ProducerService,
    AppService,
    CartStorageService,
    CartApiService,
    SsrService,
    {
      provide: TrackResolverAbstract,
      useClass: StubTrackResolver
    },
    { provide: CoreSettingsService, useClass: LocalCoreSettingsService },
    { provide: 'ILanguageService', useFactory: i18ServiceFactory, deps: [StorageService] },
    { provide: I18nService, useFactory: i18ServiceFactory, deps: [StorageService] },
    { provide: InternationalizationService, useFactory: i18ServiceFactory, deps: [StorageService] },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: WithCredentialsInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LangInterceptor,
      multi: true
    },
    Title,
    {
      provide: AppLogger,
      useFactory: appLoggerFactory,
      deps: [CoreSettingsService]
    },
    {
      provide: SHOPPING_CART_APP_TYPE,
      useValue: shoppingCartApp.Producer
    },
    provideHttpClient(withXhr(), withInterceptorsFromDi())
  ]
})
export class AppModule {}
